module.exports = __webpack_public_path__ + "static/img/scene5.9ca25098.png";